import { defineMessages } from "react-intl";

const messages = defineMessages({
  checkInTypesMessage: {
    id: "createEditActivityModal.field.activityType.checkInTypes.message",
    defaultMessage: "Some activity types may be disabled for Check-In activities",
    description: "Message for the CheckIn Activity Types while editing CheckIn Activity",
  },
  duplicated: {
    id: "createActivityModal.cloningInfo",
    defaultMessage: 'Make any desired modifications and click "Create Activity" to duplicate.',
    description: "Information for duplicated activities",
  },
  emptyTextForWithSkippedUsers: {
    id: "createEditActivityModal.field.note.emptyTextForWithSkippedUsers",
    defaultMessage:
      "Only users that have view or edit access to either the association or the activity can be mentioned",
    description:
      "Message for the Activity Note mention dropdown when some disabled users are skipped",
  },
  header: {
    id: "createActivityModal.header",
    defaultMessage: "Create Activity",
    description: "Header of Create Activity modal",
  },
  logActivity: {
    id: "createActivityModal.footer.logActivity",
    defaultMessage: "Log Activity",
    description: "Log Activity button title on Create Activity modal",
  },
  placeholder: {
    id: "createEditActivityModal.field.activityType.placeholder",
    defaultMessage: "Select",
    description: "Placeholder for the Activity Type field on the Create Activity modal",
  },
  requiredFields: {
    id: "createActivityModal.requiredFieldAlert",
    defaultMessage: "Fill out all required fields to log activity.",
    description: "Required Field alert while logging activity",
  },
  saveActivity: {
    id: "createActivityModal.footer.saveActivity",
    defaultMessage: "Save Activity",
    description: "Save Activity button title on Create Activity modal",
  },
  scheduleActivity: {
    id: "createActivityModal.footer.scheduleActivity",
    defaultMessage: "Schedule Activity",
    description: "Schedule Activity button title on Create Activity modal",
  },
  scheduleAnotherFollowUp: {
    id: "createActivityModal.footer.scheduleFollowUp.checkbox.another",
    defaultMessage: "Schedule another follow-up",
    description: "Schedule another follow-up label on Create Activity modal",
  },
  scheduleFollowUp: {
    id: "createActivityModal.footer.scheduleFollowUp.title",
    defaultMessage: "Schedule Follow-up",
    description: "Schedule follow-up ",
  },
  scheduleFollowUpNext: {
    id: "createActivityModal.footer.scheduleFollowUp.checkbox",
    defaultMessage: "Schedule follow-up on next step",
    description: "Schedule follow-up label on Create Activity modal",
  },
  tooltip: {
    id: "createActivityModal.footer.previewMode.tooltip",
    defaultMessage: "Please exit Preview Mode to log activity",
    description: "Create Activity modal - OK button tooltip in preview mode",
  },
  visibility: {
    id: "createEditActivityModal.field.visibility",
    defaultMessage: "Visible to",
    description: "Visibility field label in Create create edit activity modal",
  },
});

export default messages;
